module.exports = __webpack_public_path__ + "img/hair.e15a50f7.svg";